export enum ChatMessageStatus {
  Sending,
  Sent,
  Read,
  Failed,
}
